import React from 'react';
import { Redirect, useLocation } from 'react-router-dom';

import {
  clearRegisterUri,
  registerUriFromPath,
  storeRegisterUri,
} from '../utils/registerUriArgs';

function RegisterToAuthRedirect() {
  const location = useLocation();
  const registerUri = registerUriFromPath(location.pathname);
  if (registerUri) {
    storeRegisterUri(registerUri);
  } else {
    clearRegisterUri();
  }

  return (
    <Redirect
      to={{
        pathname: '/auth',
        search: location.search || '',
        state: registerUri ? { registerUri } : undefined,
      }}
    />
  );
}

export default RegisterToAuthRedirect;
